export const COUPON_LIST_GET_REQUEST = 'COUPON_LIST_GET_REQUEST';
export const COUPON_LIST_GET_SUCCESS = 'COUPON_LIST_GET_SUCCESS';
export const COUPON_OPEN_DRAWER = 'COUPON_OPEN_DRAWER';
export const COUPON_DRAWER_LOADED = 'COUPON_DRAWER_LOADED';
export const TRACK_OPEN_COUPON_DRAWER_EVENT = 'TRACK_OPEN_COUPON_DRAWER_EVENT';
export const TRACK_PRINT_BAR_CODE_EVENT = 'TRACK_PRINT_BAR_CODE_EVENT';
export const TRACK_COUPON_SEE_DETAIL_EVENT = 'TRACK_COUPON_SEE_DETAIL_EVENT';
export const COUPON_OPEN_DETAILS = 'COUPON_OPEN_DETAILS';
